import HttpRequest from './httpRequest'

export default class LineOfficialAccountProvider extends HttpRequest {
  fetchLineOfficialAccountByBasicId (basicId) {
    return this.fetch(`/line-official-accounts/basic-id/${basicId}`)
  }

  updateLineOfficialAccount (params) {
    return this.update('/line-official-accounts', params)
  }
}
